'use strict';

export default class ConfirmController {

  /*@ngInject*/
  constructor($http, $stateParams, $state, $rootScope) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.$rootScope = $rootScope;
    this.$rootScope.public_page = true;

  }

  $onInit() {
    this.confirm();
  }

  confirm() {
    this.$http.get(`/api/devices/confirm?code=${this.$stateParams.code}`).then(res => {
      this.message = res.data.data.msg;
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/devices/confirm/confirm.controller.js